import FilterAltIcon from "@mui/icons-material/FilterAlt"
import Grid from "@mui/material/Grid2"
import moment from "moment"
import React, { useEffect, useState, useRef } from "react"
import { momentLocalizer } from "react-big-calendar"
import "react-big-calendar/lib/css/react-big-calendar.css"
import CustomMenu from "../GlobalComponents/CustomMenu"
import { FormField } from "../GlobalComponents/Fields"
import { EventCards } from "./Events"
import "./index.css"
import { sideBarStatusOptions } from "../../utils/constants"
import { getFormattedDate } from "../../utils/Helpers"
import { CustomButton } from "../GlobalComponents/CommonComponents"
import { useReactToPrint } from "react-to-print";
const localizer = momentLocalizer(moment)

function Sidebar(props) {
  const {
    selectedEvents,
    selectedDate,
    selectedUsersData,
    activeUsers,
    handleChange,
    filteredEvents,
    getScheduleData = () => { },
    onSelectEventCard
  } = props

  const [selectedOption, setSelectedOption] = useState(sideBarStatusOptions[0])
  function onChangeOption(option) {
    if (typeof option === "string") {
      setSelectedOption(option)
    }
  }

  const contentRef = useRef(null);
  const reactToPrintFn = useReactToPrint({ contentRef });

  useEffect(() => {
    setSelectedOption(sideBarStatusOptions[0])
  }, [selectedDate])

  const onClickPrint = () => {
    reactToPrintFn()
  }

  return (
    <Grid item className="day-sidebar" xs={12} md={3}>
      <div
        ref={contentRef}

        style={{
          // height: "80%",
          border: "0px solid blue",
          padding: "12px",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <div

        >
          <div>
            <span
              style={{
                margin: "0px",
                fontSize: "16px",
              }}
            >
              Events on {selectedDate ? getFormattedDate(selectedDate) : "No Date Selected"}
            </span>
          </div>

          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              maxWidth: "100%",
              marginTop: "5px"
            }}
          >

            <div style={{ width: "100%" }}>
              <FormField
                deattach={false}
                labelClassName="patient-form-label"
                type="dropdown"
                // label="Gender"
                options={selectedUsersData}
                name="gender"
                value={activeUsers}
                onChange={handleChange}
                placeholder="Gender"
                dropDownSelectStyle={{
                  // border: "2px solid red",
                  // width: "50px",
                  height: "40px",
                }}
              />
            </div>


            <CustomMenu
              selectedOption={selectedOption}
              Icon={<FilterAltIcon size={30} />}
              options={sideBarStatusOptions}
              onChange={onChangeOption}
            />


            <CustomButton
              text="Print"
              sx={{ fontWeight: "bold", height: "40px" }}
              disabled={filteredEvents?.length === 0}
              onClick={onClickPrint}
            />
          </div>
        </div>

        <div
          style={{
            marginTop: "10px",
            padding: "2px",
            overflowY: "auto",
            flex: 1,
            maxHeight: "500px",
          }}
        >
          <EventCards
            events={filteredEvents}
            selectedOption={selectedOption}
            getScheduleData={getScheduleData}
            onSelectEventCard={onSelectEventCard}
          />
        </div>
      </div>
      {/* <Sidebar
            selectedEvents={selectedEvents} selectedDate={selectedDate} />  */}
    </Grid>
  )
}

export default Sidebar

// return (
//     <div>
//         <div
//             style={{
//                 width: "100%",
//                 display: "flex",
//                 justifyContent: "space-between",
//                 alignItems: "center",
//                 marginBottom: 8,
//             }}
//         >
//             <div style={{ display: "flex", alignItems: "center" }}>
//                 <IconButton onClick={handleDecreaseDate}>
//                     <ArrowLeftIcon />
//                 </IconButton>

//                 {openCalender ? (
//                     <LocalizationProvider dateAdapter={AdapterDayjs}>
//                         <DatePicker
//                             sx={{ width: "80%" }}
//                             format="DD-MMM-YYYY"
//                             open={openCalender}
//                             onClose={handleCloseCalender}
//                             onChange={handleSelectedDate}
//                             PopperComponent={(props) => (
//                                 <Popper
//                                     {...props}
//                                     anchorEl={anchorCalEl}
//                                     placement="bottom-start"
//                                 />
//                             )}
//                             defaultValue={parseDate(selectedDate)} // Convert string to dayjs object
//                             value={parseDate(selectedDate)} // Convert string to dayjs object
//                             renderInput={(params) => (
//                                 <TextField
//                                     {...params}
//                                     InputProps={{
//                                         ...params.InputProps,
//                                         readOnly: true,
//                                     }}
//                                 />
//                             )}
//                         />
//                     </LocalizationProvider>
//                 ) : (
//                     <p
//                         className="selected_date"
//                         onClick={() => setOpenCalender(true)} // Show DatePicker on click
//                         style={{ cursor: "pointer", margin: "0 8px" }}
//                     >
//                         {selectedDate
//                             ? moment(selectedDate, "DD-MM-YYYY").format(
//                                 "DD-MMM-YYYY"
//                             )
//                             : "Select a date"}
//                     </p>
//                 )}

//                 {!openCalender && (
//                     <IconButton onClick={() => setOpenCalender(true)}>
//                         <MdOutlineCalendarMonth />
//                     </IconButton>
//                 )}

//                 <IconButton onClick={handleIncreaseDate}>
//                     <ArrowRightIcon />
//                 </IconButton>
//             </div>

//             {UserRole !== "endUser" && !isEmpty(filteredEventsData) && (
//                 <FormControl variant="outlined" sx={{ minWidth: 100 }}>
//                     <Select
//                         id="filter-select"
//                         value={filteredOption}
//                         onChange={(event) => {
//                             setFilteredOption(event.target.value); // Update the selected filter option
//                             handleOnSelectFilters(event.target.value);
//                         }}
//                         sx={{ fontSize: "14px" }} // Set font size for dropdown text
//                     >
//                         {filteredOptions?.map((each, index) => (
//                             <MenuItem
//                                 key={index}
//                                 value={each.value}
//                                 sx={{
//                                     backgroundColor:
//                                         each.value === filteredOption
//                                             ? "#c8dcf6"
//                                             : "inherit",
//                                 }}
//                             >
//                                 {each.name}
//                             </MenuItem>
//                         ))}
//                     </Select>
//                 </FormControl>
//             )}
//         </div>
//     </div>
// )
